@if (!hasNoIcon) {
<app-image [name]="icon" [responsive]="responsive" [width]="size"></app-image>
} @else {
<div class="app-avatar" [ngClass]="{ nophoto: hasNoText }" [style.height]="size" [style.width]="size" [style.line-height]="size">
  @if (!hasNoText) {
  <span>{{ text | avatarText }}</span>
  }
</div>
} @if (displayPaymentStatusIcon) {
<app-image [name]="paymentStatus+'-payment'" [responsive]="responsive" [miniAdditionalIcon]="true"></app-image>
} @if (alert) {
<a class="app-avatar-alert" nz-popover [nzPopoverContent]="alert" [dir]="direction">
  <app-image [inlineSvg]="false" name="alert-circle"></app-image>
</a>
}
